<button class=
  "bg-gold-500 text-black active:bg-gold-600 font-bold uppercase text-4xl
  px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none
  mr-1 mb-1 ease-linear transition-all duration-150"
  type="button"
  (click)="onClick($event)"
>
  {{ text }}
</button>
